export default defineNuxtPlugin({
  name: 'error-handling',
  hooks: {
    'app:chunkError'() {
      // This should prevent crashes after new deployments
      try {
        const url = URL.parse(window.location.href)!
        url.searchParams.set('force-reload', Date.now().toString())
        // Reload with the new URL and added search param
        window.location.href = url.toString()
      } catch {
        // Fallback to simple reload
        window.location.reload()
      }
    },
  },
})
